// extracted by mini-css-extract-plugin
module.exports = {"Container":"DealLayout_Container__QikV5","Transparent":"DealLayout_Transparent__V0Buw","White":"DealLayout_White__Byc7I"};